import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { LoadModalWithLabel } from "../modais"
import {
  InputCustom,
  TextArea,
  HttpError,
  SelectCustom,
  Loading
} from "../../components"
import * as ApiHelper from "../../ApiHelper"
import * as constants from "../../constants"
import Util from "../../Util"
import { ToastContainer, ToastMessage } from "react-toastr"
class DiarioOcorrenciasForm extends Component {
  constructor() {
    super()
    this.onChangeFiscal = this.onChangeFiscal.bind(this)
    this.getFiscalWithId = this.getFiscalWithId.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.onChangeDataExecucao = this.onChangeDataExecucao.bind(this)
    this.onChangeExecucaoContratual = this.onChangeExecucaoContratual.bind(this)
    this.onChangeDataProvidencias = this.onChangeDataProvidencias.bind(this)
    this.onChangeProvidencias = this.onChangeProvidencias.bind(this)
    this.onChangeDataResultados = this.onChangeDataResultados.bind(this)
    this.onChangeResultados = this.onChangeResultados.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.getInitialFields = this.getInitialFields.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      showForm: false,
      fiscais: [],
      fiscal: "",
      contratos: [{ value: null, label: "" }],
      contrato: "",
      resultados: "",
      providencias: "",
      execucaoContratual: "",
      dataResultados: "",
      dataProvidencias: "",
      dataExecucaoContratual: ""
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  showSucessMessage() {
    var message = ""
    var title = "Sucesso"
    if (this.props.isEditing) {
      message = "Diário de ocorrências atualizado com sucesso"
    } else {
      message = "Diário de ocorrências cadastrado com sucesso"
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }
  componentWillMount() {
    if (this.props.isEditing) {
      this.getInitialFields()
    } else {
      this.getFiscais()
    }
  }
  getFiscais() {
    if (!constants.userIsFiscal()) {
      ApiHelper.getFiscais((fiscais, error) => {
        if (fiscais) {
          this.setState(
            {
              fiscais: Util.mapFiscais(fiscais),
              showForm: true
            },
            () => {
              window.scrollTo(0, 0)
            }
          )
        } else {
          this.setState({
            httpError: error
          })
        }
      })
    } else {
      ApiHelper.getMe(() => {
        var contratos = Util.mapContratos(constants.getUserContratos())
        this.setState({
          fiscal: constants.getUserID(),
          showForm: true,
          contratos: contratos
        })
      })
    }
  }
  getInitialFields() {
    ApiHelper.getDiarioOcorrenciaEdit(
      this.props.match.params.id,
      (data, error) => {
        if (data) {
          this.fillFields(data.diario)
          this.setState(
            {
              fiscais: data.fiscais,
              showForm: true
            },
            () => {
              var fiscalID = data.diario.contrato.fiscal_id
              var contratos = this.getFiscalWithId(fiscalID).contratos
              this.setState(
                {
                  contratos: Util.mapContratos(contratos),
                  fiscal: fiscalID
                },
                () => {
                  window.scrollTo(0, 0)
                }
              )
            }
          )
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  fillFields(fields) {
    var currentFields = {
      contrato: fields.num_contrato,
      dataExecucaoContratual: fields.dt_exec_contratual,
      execucaoContratual: fields.exec_contratual,
      dataProvidencias: fields.dt_providencias,
      providencias: fields.providencias,
      dataResultados: fields.dt_resultados,
      resultados: fields.resultados,
      fiscal: fields.fiscal_id
    }
    this.setState(currentFields)
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      num_contrato: this.state.contrato,
      dt_exec_contratual: Util.dateOnly(this.state.dataExecucaoContratual),
      exec_contratual: this.state.execucaoContratual,
      dt_providencias: Util.dateOnly(this.state.dataProvidencias),
      providencias: this.state.providencias,
      dt_resultados: Util.dateOnly(this.state.dataResultados),
      resultados: this.state.resultados
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateDiarioOcorrencia(
        this.props.match.params.id,
        params,
        error => {
          this.toggleLoadModal()
          if (error) {
            this.showErrorMessage()
            this.handleErrors(error)
          } else {
            this.showSucessMessage()
            Util.sleep(3000).then(() => {
              this.props.callBackDiarioDeOcorrencia()
            })
          }
        }
      )
    } else {
      ApiHelper.sendDiarioOcorrencia(params, error => {
        this.toggleLoadModal()
        if (error) {
          this.showErrorMessage()
          this.handleErrors(error)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackDiarioDeOcorrencia()
          })
        }
      })
    }
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  onChangeResultados(event) {
    var newValue = event.target.value
    this.setState({
      dt_resultados: "",
      resultados: newValue
    })
  }
  onChangeDataResultados(value) {
    this.setState({
      dt_resultadosError: "",
      dataResultados: Util.dateOnly(value)
    })
  }
  onChangeProvidencias(event) {
    var newValue = event.target.value
    this.setState({
      providenciasError: "",
      providencias: newValue
    })
  }
  onChangeDataProvidencias(value) {
    this.setState({
      dt_providenciasError: "",
      dataProvidencias: Util.dateOnly(value)
    })
  }
  onChangeDataExecucao(value) {
    this.setState({
      dt_exec_contratualError: "",
      dataExecucaoContratual: Util.dateOnly(value)
    })
  }
  onChangeExecucaoContratual(event) {
    var newValue = event.target.value
    this.setState({
      exec_contratualError: "",
      execucaoContratual: newValue
    })
  }
  getFiscalWithId(id) {
    var fiscalFound = ""
    this.state.fiscais.forEach(fiscal => {
      if (fiscal.value === parseInt(id, 10)) fiscalFound = fiscal
    })
    return fiscalFound
  }
  onChangeContrato(event) {
    var newValue = event.target.value
    this.setState({
      num_contratoError: "",
      contrato: newValue
    })
  }
  onChangeFiscal(event) {
    var newValue = event.target.value
    this.setState(
      {
        fiscal_idError: "",
        contrato: "",
        fiscal: newValue
      },
      () => {
        var contratos = this.getFiscalWithId(this.state.fiscal).contratos
        this.setState(
          {
            contratos: contratos ? Util.mapContratos(contratos) : []
          },
          () => {
            if (this.state.contratos.length === 1) {
              this.setState({
                fiscal_idError: "Este fiscal não possui contratos cadastrados"
              })
            }
          }
        )
      }
    )
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <div>
          {this.state.showForm === false && <Loading />}
          {this.state.showForm === true && (
            <div className="card card-plain">
              <ToastContainer
                ref={input => {
                  this.container = input
                }}
                toastMessageFactory={this.toastFactory}
                className="toast-top-right"
                preventDuplicates={true}
              />
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">
                  {this.props.isEditing
                    ? "Editar diário de ocorrências"
                    : "Criar diário de ocorrências"}
                </h4>
                <p className="category">
                  {this.props.isEditing
                    ? "Diário de ocorrências do contrato Nº : " +
                      this.state.num_contratoLabel
                    : "Criar novo diário de ocorrências"}
                </p>
              </div>
              <div className="card-content">
                <form>
                  <div className="row">
                    {!constants.userIsFiscal() && (
                      <SelectCustom
                        error={this.state.fiscal_idError}
                        sizeClass="col-md-4"
                        options={this.state.fiscais}
                        label="Selecione um fiscal"
                        name="fiscal"
                        value={this.state.fiscal}
                        onChange={this.onChangeFiscal}
                      />
                    )}
                  </div>
                  {this.state.contratos.length > 1 && (
                    <div>
                      <div className="row">
                        <SelectCustom
                          error={this.state.num_contratoError}
                          sizeClass="col-md-4"
                          options={this.state.contratos}
                          label={"Selecione um contrato"}
                          name={"contrato"}
                          value={this.state.contrato}
                          onChange={this.onChangeContrato}
                        />
                      </div>
                      <div className="card ">
                        <div
                          className="card-header"
                          data-background-color="as-blue"
                        >
                          <h5 className="title">Execução contratual</h5>
                        </div>
                        <div className="card-content">
                          <div className="row">
                            <InputCustom
                              error={this.state.dt_exec_contratualError}
                              sizeClass="col-md-2"
                              label={"Data"}
                              type="date"
                              onChange={this.onChangeDataExecucao}
                              value={this.state.dataExecucaoContratual}
                            />
                          </div>
                          <div className="row">
                            <TextArea
                              error={this.state.exec_contratualError}
                              sizeClass="col-md-10"
                              subTitle="Entre com o texto abaixo"
                              label=""
                              onChange={this.onChangeExecucaoContratual}
                              value={this.state.execucaoContratual}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card ">
                        <div
                          className="card-header"
                          data-background-color="as-blue"
                        >
                          <h5 className="title">
                            Providências / Documentos Expedidos
                          </h5>
                        </div>
                        <div className="card-content">
                          <div className="row">
                            <InputCustom
                              error={this.state.dt_providenciasError}
                              sizeClass="col-md-2"
                              label={"Data"}
                              type="date"
                              onChange={this.onChangeDataProvidencias}
                              value={this.state.dataProvidencias}
                            />
                          </div>
                          <div className="row">
                            <TextArea
                              error={this.state.providenciasError}
                              sizeClass="col-md-10"
                              subTitle="Entre com o texto abaixo"
                              label=""
                              onChange={this.onChangeProvidencias}
                              value={this.state.providencias}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card ">
                        <div
                          className="card-header"
                          data-background-color="as-blue"
                        >
                          <h5 className="title">Resultados</h5>
                        </div>
                        <div className="card-content">
                          <div className="row">
                            <InputCustom
                              error={this.state.dt_resultadosError}
                              sizeClass="col-md-2"
                              label={"Data"}
                              type="date"
                              onChange={this.onChangeDataResultados}
                              value={this.state.dataResultados}
                            />
                          </div>
                          <div className="row">
                            <TextArea
                              error={this.state.resultadosError}
                              sizeClass="col-md-10"
                              subTitle="Entre com o texto abaixo"
                              label=""
                              onChange={this.onChangeResultados}
                              value={this.state.resultados}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <button
                    onClick={this.sendForm}
                    type="submit"
                    className="btn btn-primary pull-right"
                    data-background-color="as-blue"
                  >
                    {this.props.isEditing ? "Salvar" : "Criar"}
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}
export default withRouter(DiarioOcorrenciasForm)



// WEBPACK FOOTER //
// ./src/views/modais/DiarioOcorrenciasForm.js